export default {
  title: "RC CITY haqida Batafsil Ma’lumot",

  balance: {
    title: "Balans",
    info: {
      title: "Balans haqida ma’lumot",
      paragraphs: [
        "Balansda o‘zaro hisob-kitob davrida sizga to‘lanadigan mablag‘lar haqida ma’lumot aks etadi.",
        "Shuningdek, “Balans” sahifasida sizning moliyaviy holatingizni yaxshiroq nazorat qilish va mavjud mablag‘laringizni tushunishga yordam beradigan to‘liq tafsilotlar keltirilgan.",
      ],
    },
    settings: {
      title: "Pul yechib olish sozlamalari",
      paragraphs: [
        "Pul mablag‘larini yechib olish uchun sozlamalarda to‘lov usulini tanlash kerak. To‘lov shartnomaning 4.6-bandiga muvofiq amalga oshiriladi. Agar RC CITY kabinetida hech bir usul tanlanmasa, belgilangan davrda ushbu yuridik shaxsga to‘lov amalga oshirilmaydi.",
        "Yechib olinadigan summani belgilash uchun quyidagilarni bajaring:",
      ],
      list: [
        {
          text: "O‘ng yuqori burchakdagi «Balans» tugmasini bosib, «Balans» bo‘limiga o‘ting.",
        },
        {
          text: "Balans kartasida «Sozlamalar» tugmasini bosing.",
        },
        {
          text: "Pul yechib olish usulini tanlang:",
          list: [
            "«Chiqarishga zaxiralangan summa» bo‘yicha — Mablag‘lar to‘lov amalga oshirilguniga qadar zaxiraga olinadi va tarif yoki xizmatlar xaridida ishlatilmaydi, chunki haqiqiy balans belgilangan summaga kamayadi. Agar «Chiqarishga mavjud summa» 300 RC dan kam bo‘lsa, bu usul mavjud bo‘lmaydi. Summani siz mustaqil belgilaysiz.",
            "«Chiqarishga mavjud summa» bo‘yicha — To‘lov o‘zaro hisob-kitob paytidagi balansdagi “Chiqarishga mavjud” summaga teng miqdorda amalga oshiriladi, agar u 300 RC dan kam bo‘lmasa.",
          ],
        },
        {
          text: "«Qo‘llash va yopish» tugmasini bosing.",
        },
      ],
    },
  },

  analytic: {
    title: "Analitika",
    entities: {
      title: "Yuridik shaxslar",
      paragraphs: [
        "<b>«Analitika»</b> bo‘limida RC PAY’dan foydalanuvchi barcha filiallaringiz va mijozlaringiz bo‘yicha tahliliy ma’lumotlar keltirilgan. Ma’lumotlar beshta qismga bo‘lingan bo‘lib, har biri turli yo‘nalishdagi ma’lumotlarga e’tibor qaratadi.",
        "<b>«Yuridik shaxslar»</b> bo‘limida mijozlar bo‘yicha umumiy ma’lumotlar, shu jumladan yangi mijozlar, o‘rtacha chek, xaridlar soni va umumiy savdo summasini ko‘rish mumkin. Shuningdek, har bir ro‘yxatdan o‘tgan tashkilot bo‘yicha batafsil ma’lumot olish va sizni qiziqtirgan davrni tanlash orqali kunlik, haftalik, oylik yoki yillik savdolarni ko‘rish imkoniyati mavjud.",
      ],
    },
    points: {
      title: "Savdo nuqtalari",
      p1: "<b>«Savdo nuqtalari»</b> bo‘limida avvalgi bo‘limning kengaytirilgan tahlili joylashgan:",
      list: [
        "mijozlar haqidagi ma’lumotlar;",
        "savdolar;",
        "tanlangan davr uchun savdolar summasi;",
        "har bir tashkilot bo‘yicha ma’lumot;",
        "xodimlarning faolligi haqida ma’lumot;",
        "har bir xodimning savdo summasi;",
        "kassirlarga berilgan ballar.",
      ],
      p2: "<b>«Barcha savdo nuqtalari»</b> ni tanlab, barcha mavjud savdo nuqtalari bo‘yicha umumiy ma’lumotni ko‘rish mumkin.",
    },
    employees: {
      title: "Xodimlar",
      p1: "<b>«Xodimlar»</b> bo‘limida siz xodimlaringizning faolligini kuzatib borishingiz va ularning samaradorligini ma’lum davr uchun quyidagi mezonlar asosida baholashingiz mumkin:",
      list: [
        "tranzaksiyani amalga oshirgan xodimning ismi;",
        "savdo nuqtasi;",
        "savdolar soni;",
        "savdolar summasi;",
        "kassir ballari;",
        "yechilgan ballar soni;",
        "hisoblangan ballar soni.",
      ],
      p2: "<b>«Barcha savdo nuqtalari»</b> ni tanlab, barcha nuqtalar bo‘yicha umumiy ma’lumotni ko‘rish mumkin.",
    },
    rfm: {
      title: "RFM-tahlil",
      paragraphs: [
        "<b>«RFM-tahlil»</b> bo‘limida mijozlarni xarid qilish chastotasi va summasi bo‘yicha segmentatsiya tahlili keltirilgan. Bu sizdan eng ko‘p xarid qiladigan mijozlarni aniqlashga yordam beradi.",
        "Ma’lumotni olish uchun ochiladigan menyudan <b>«Yuridik shaxs»</b> ni va <b>«Kalendar»</b> dan davrni tanlang. Natijada <b>«Ballarni hisoblash»</b> bo‘limida shakllantirilgan guruhlar bo‘yicha tahlil jadvali ko‘rsatiladi.",
      ],
    },
    portrait: {
      title: "Mijoz portreti",
      paragraph:
        "<b>«Mijoz portreti»</b> bo‘limida tanlangan tashkilotning barcha mijozlari haqidagi batafsil ma’lumotni ko‘rish va doimiy mijozlarni aniqlash mumkin. Yosh toifalari grafigida quyidagi ma’lumotlar mavjud:",
      list: [
        "ushbu yosh toifasidagi mijozlar soni;",
        "ularning o‘rtacha cheki;",
        "xaridlar soni;",
        "xaridlar summasi.",
      ],
    },
  },

  loyalty: {
    title: "Sodiqlik dasturi",

    accrualPoints: {
      title: "Ballarni hisoblash",
      p1: "<b>«Ballarni hisoblash»</b> bo‘limida siz mijozlarga beriladigan ballar foizini sozlashingiz mumkin. Minimal foiz – 4%, maksimal foiz esa – 25%. Mijozlar sodiqligini oshirish uchun ularni xaridlar summasiga qarab guruhlarga ajrating va har bir guruh uchun o‘z mukofot foizini belgilang.",
      p2: "Mijozlar guruhini yaratish uchun quyidagi amallarni bajaring:",
      list: [
        {
          text: "Mijozlar guruhini yaratmoqchi bo‘lgan savdo nuqtalarini tanlang. Masalan:",
          list: [
            "Yangi mijoz – xaridlar summasi 10 000 so‘mgacha bo‘lsa, mukofot 5%.",
            "Doimiy mijoz – xaridlar summasi 10 000 so‘mdan yuqori bo‘lsa, mukofot 10%.",
            "Sodiq mijoz – xaridlar summasi 50 000 so‘mdan yuqori bo‘lsa, mukofot 20%.",
          ],
        },
        { text: "«Guruh yaratish» tugmasini bosing." },
      ],
      p3: "Ushbu sahifada siz <b>«Savdo nuqtasining joriy kechikishini»</b> ham belgilashingiz mumkin – bu xarid uchun mukofot ballari mijozga hisoblanadigan kungacha bo‘lgan muddatdir. Qiymat 0 dan 14 kungacha bo‘lishi mumkin. <b>«Kechikishni o‘zgartirish»</b> tugmasini bosib, kerakli muddatni kiriting, so‘ngra <b>«Saqlash»</b> tugmasini bosing. Eslatma: bu funksiya faqat RC CITY balansida yetarli mablag‘ bo‘lganda to‘g‘ri ishlaydi.",
    },

    promo: {
      title: "Aksiyalar",
      p1: "<b>«Aksiyalar»</b> bo‘limida siz filiallaringiz uchun aksiyalar yaratishingiz va ularni bir vaqtda yoki alohida kuzatishingiz mumkin. Ma’lumot jadval ko‘rinishida taqdim etiladi: aksiya nomi, o‘tkaziladigan savdo nuqtasi, ballarni hisoblash foizi (avvalgi bo‘limdagi foizlar bilan qo‘shilmaydi), va chegirma foizi. Har bir aksiya yonida <b>RC KASSA</b> orqali yashirish, tahrirlash yoki o‘chirish imkoniyati mavjud.",
      p2: "Aksiya yaratish uchun ochilgan oynada quyidagilarni kiriting:",
      list: [
        "savdo nuqtasi;",
        "aksiya nomi;",
        "ballarni hisoblash foizi;",
        "chegirma foizi.",
      ],
      p3: "Aksiya muvaffaqiyatli yaratilgach, xodim sifatida <b>RC KASSA</b> dasturiga kirib, <b>«Aksiyalar»</b> tugmasini bosganingizda, siz yaratgan aksiya ko‘rinadi.",
    },

    operations: {
      title: "Operatsiyalar tarixi",
      paragraphs: [
        "<b>«Barcha operatsiyalar»</b> bo‘limida <b>«Operatsiyalar tarixi»</b> sahifasida RC CITY balansidagi barcha to‘ldirishlar va mablag‘ yechishlar jadval ko‘rinishida ko‘rsatiladi. Batafsil ma’lumot olish uchun kalendardan kerakli davrni tanlang.",
        "Shuningdek, ushbu sahifadan ma’lum davr yoki butun vaqt oralig‘idagi operatsiyalar tarixini yuklab olish mumkin. Buning uchun <b>«Yuklab olish»</b> tugmasini bosing, yuklash formatini tanlang va istasangiz <b>«Nusxasini elektron pochtaga yuborish»</b> belgichasini qo‘ying. Bunda fayl RC CITY ro‘yxatidan o‘tishda ko‘rsatilgan pochtangizga yuboriladi. Shundan so‘ng yana «Yuklab olish» tugmasini bosing.",
        "<b>RC Processing</b> bo‘limida kassalardagi barcha amalga oshirilgan operatsiyalar haqida ma’lumot beriladi.",
      ],
    },
  },

  clients: {
    title: "Mijozlar",
    clients: {
      title: "Mijozlar ro‘yxati",
      paragraphs: [
        "«Mijozlar ro‘yxati» bo‘limida siz xaridorlaringiz haqidagi ma’lumotlarni ko‘rishingiz mumkin. Ma’lumotlarni ko‘rish uchun tashkilotni tanlang yoki «Barcha tashkilotlar» belgisini qo‘ying.",
        "<b>«Barcha mijozlar»</b> oynasida siz muassasangizdagi barcha mijozlar haqidagi ma’lumotlarni ko‘rasiz. <b>«Ichki mijozlar»</b> oynasida sizning muassasangizda raqamlashtirilgan mijozlar ko‘rsatiladi. <b>«Tashqi mijozlar»</b> oynasida sizning muassasangizga tashrif buyurib, kamida bir marta xarid qilgan mijozlar haqida ma’lumot beriladi.",
        "Sahifaning pastki qismida <b>«Taklif qilish»</b> tugmasi mavjud — u orqali siz mijozni ro‘yxatdan o‘tkazish uchun havolani nusxalashingiz yoki QR-kodni yuklab olishingiz mumkin.",
      ],
    },
    reviews: {
      title: "Sharhlar",
      p1: "«Sharhlar» bo‘limida sizning muassasangizga tashrif buyurib, rcpay.ru saytida yoki RC PAY ilovasida fikr qoldirgan barcha mijozlarning sharhlari ko‘rsatiladi.",
      p2: "Sharhlar bilan qulay ishlash uchun bir nechta filtrlar mavjud:",
      list: [
        {
          text: "<b>«Savdo nuqtasini tanlang»</b> tugmasini bosganingizda, tanlangan nuqta bo‘yicha barcha sharhlar ko‘rsatiladi. Agar <b>«Barcha savdo nuqtalari»</b> bandini tanlasangiz, barcha nuqtalar bo‘yicha sharhlarni ko‘rasiz.",
        },
        {
          text: "Muayyan davr yoki sana bo‘yicha sharhlarni ko‘rish mumkin. Buning uchun kalendarni oching va kerakli davrni tanlang yoki uni qo‘lda belgilang.",
        },
        {
          text: "Sharhlarni quyidagi 3 mezon bo‘yicha filtrlash mumkin:",
          list: ["yangiligi bo‘yicha;", "faqat ijobiylar;", "faqat salbiylar."],
        },
      ],
      p3: "Siz shuningdek saytda va RC PAY ilovasida ko‘rsatiladigan muayyan sharhlarni tanlashingiz mumkin. Buning uchun ko‘rsatilishini istagan sharhlar yonidagi ko‘rish belgisini bosing. E’tibor bering, yashirilgan sharhlar muassasaning reytingiga ta’sir qilmaydi.",
    },
    push: {
      title: "Wallet Push-xabarnomalari",
      p1: "<b>«Wallet Push-xabarnomalari»</b> bo‘limida siz mijozlaringizni aksiyalar va tadbirlar haqida xabardor qilish uchun push-xabarlarni sozlashingiz mumkin.",
      list: [
        "Buning uchun «Push-xabar yaratish» yonidagi plus belgini bosing va kerakli maydonlarni to‘ldiring;",
        "Xabar yuboriladigan savdo nuqtasini tanlang;",
        "Sarlavha matnini kiriting (masalan: «barchaga bayram chegirmalari»);",
        "Push-xabarning matnini kiriting. E’tibor bering, xabar yaratilib bo‘lingach, uni o‘zgartirish mumkin emas. Barcha yuborilgan xabarlar shu sahifada jadval ko‘rinishida ko‘rsatiladi. Har bir xabar bo‘yicha «Batafsil» tugmasini bosib, savdo nuqtasi, yuborilgan sana va matnni ko‘rishingiz mumkin.",
      ],
      p2: "Sizning mijozlaringiz xabarni 15 daqiqa ichida olishadi. Eslatma: xabar yaratilgandan so‘ng uni o‘zgartirish mumkin emas. Barcha yuborilgan xabarlar shu sahifada jadval shaklida ko‘rsatiladi. Har biri bo‘yicha «Batafsil» tugmasini bosib, ma’lumotlarni ko‘rish mumkin.",
    },
  },

  cards: {
    title: "Sodiqlik kartalari",
    spread: {
      title: "RC kartalarini tarqatish",
      p: "Wallet kartasi — bu do‘kon va muassasalar kartalarining elektron ekvivalenti. <b>«RC kartalarini tarqatish»</b> bo‘limida mijozlarni raqamlashtirish uchun QR-kod olish, shuningdek kartani yuklab olish havolasini olish mumkin. Ushbu havolani ijtimoiy tarmoqlarda, veb-saytingizda yoki boshqa manbalarda joylashtirib, butun dunyo bo‘ylab mijozlarni raqamlashtirish imkonini beradi.",
    },
    design: {
      title: "Wallet kartasi dizayni",
      p1: "<b>«Wallet kartasi dizayni»</b> bo‘limida kartalaringiz uchun noyob dizayn yaratish imkoniyati mavjud. Buning uchun:",
      list: [
        "«Tashkilotni tanlang» bo‘limidagi ro‘yxatdan Wallet kartasini yaratmoqchi bo‘lgan tashkilotni tanlang.",
        "Fon tanlang: «Wallet kartangiz fon rasmi uchun rasm yuklang» oynasiga faylni sudrab olib keling yoki yuklang. Fayl hajmi 2 MB dan oshmasligi va nisbat 16:9 bo‘lishi kerak.",
        "Logotipni tanlang: «Wallet kartangiz logotipi uchun rasm yuklang» oynasiga faylni sudrab olib keling yoki yuklang. Fayl hajmi 2 MB dan oshmasligi va nisbat 1:1 bo‘lishi kerak.",
        "QR-kod, sarlavha va karta raqami rangini tanlang.",
      ],
      p2: "Sozlamalarni saqlash uchun «Dizaynni o‘zgartirish» tugmasini bosing, parametrlarni tiklash uchun esa — <b>«Standart dizaynga qaytarish»</b> tugmasidan foydalaning.",
    },
  },

  employee: {
    title: "Mening xodimlarim",
    manager: {
      title: "Menejerlar",
      p1: "<b>«Menejerlar»</b> bo‘limida TSP egasi tomonidan ro‘yxatdan o‘tkazilgan barcha menejerlar ko‘rsatiladi:",
      list: ["Xodimning F.I.SH.;", "Lavozimi;", "Telefon raqami;"],
      p2: "Shuningdek, menejerni qo‘shish, o‘zgartirish, bloklash yoki o‘chirish mumkin. Menejer qo‘shish uchun «plyus» tugmasini bosib, familiya, ism, otasining ismini, lavozimini, telefon raqamini kiriting va shaxsiy kabinet sahifalariga kirish huquqlarini sozlang. Kirish uchun login va parol dastur tomonidan avtomatik tarzda yaratiladi. Eslatma: parol menejer qo‘shilgandan so‘ng faqat bir marta ko‘rsatiladi. Uni o‘zingiz uchun qulay joyda saqlab qo‘yishingiz tavsiya etiladi, chunki u keyin dasturda ko‘rinmaydi.",
      p3: "Diqqat: menejer RC KASSA ilovasida tranzaksiyalarni amalga oshirish huquqiga ega emas.",
    },
    cashier: {
      title: "Kassirlar",
      paragraphs: [
        "«Kassirlar» bo‘limida yaratilgan barcha xodimlar haqida ma’lumot beriladi. Xodim yaratish uchun «plyus» tugmasini bosing, familiya va ismni kiriting hamda xodim ishlaydigan savdo nuqtasini tanlang. Jadvalda RC KASSA'ga kirish uchun zarur bo‘lgan login, parol va xodimning holati ko‘rsatiladi.",
        "Bundan tashqari, ushbu bo‘limda to‘plangan ballar bo‘yicha ma’lumotni ko‘rish, xodimni bloklash yoki o‘chirish mumkin.",
      ],
    },
  },

  fabrics: {
    title: "Mening korxonalarim",
    entities: {
      title: "Yuridik shaxslar",
      p1: "<b>«Yuridik shaxslar»</b> bo‘limida siz mavjud tashkilotingizni qo‘shib, uning filiallariga sodiqlik dasturini tatbiq etishingiz mumkin. Buning uchun «Yuridik shaxslar» yozuvining yonidagi plyus belgisini bosing va barcha maydonlarni to‘ldiring:",
      list1: [
        "Tashkilotning INN raqami;",
        "yuridik nomi;",
        "yuridik manzili;",
        "tashkilotni xizmat ko‘rsatuvchi bank;",
        "BIC;",
        "korrespondent hisob raqami;",
        "hisob raqami;",
        "rahbarning F.I.SH.",
      ],
      p2: "Korrespondent va hisob raqamlariga alohida e’tibor bering — ular bir xil uzunlikda bo‘lishi va ortiqcha belgilar (bo‘sh joy, nuqta va h.k.) bo‘lmasligi kerak. Agar tashkilot turi «Halol» deb tanlansa, tasdiqlovchi hujjatni pdf, jpeg yoki png formatida yuklash kerak.",
      p3: "Ikkinchi va keyingi tashkilotlarni qo‘shish imkoniyati faqat pullik tariflarda mavjud. Agar sizda bir nechta tashkilot bo‘lsa, ulardan qaysi biri asosiy bo‘lishini tanlashingiz mumkin — u tarif pasayganda ham faol bo‘lib qoladi. Tashkilot yaratilgandan so‘ng, kiritilgan ma’lumotlarning moderator tomonidan tekshirilish holatini kuzatishingiz mumkin:",
      list2: [
        "«Tasdiqlandi» — barcha ma’lumotlar to‘g‘ri to‘ldirilgan va tekshiruv muvaffaqiyatli o‘tgan;",
        "«Rad etildi» — ma’lumotlar noto‘g‘ri yoki aniqlashtirish talab etiladi. Moderator izohlariga e’tibor bering — ular sizga qanday ma’lumotni to‘g‘rilash kerakligini ko‘rsatadi;",
        "«Moderatsiyada» — tashkilot tekshiruvni kutmoqda yoki hozirda tekshirilmoqda.",
      ],
      p4: "Agar moderatsiya rad etilsa, «Moderator javobi» maydonida sabab ko‘rsatilgan xabar paydo bo‘ladi. Uni diqqat bilan o‘qing va moderator tavsiyalariga amal qiling.",
      p5: "Shuningdek, tanlangan tashkilot haqida ma’lumotni nomi qarshisidagi «Batafsil» tugmasi orqali ko‘rishingiz mumkin:",
      list3: [
        "tashkilot nomi;",
        "INN;",
        "yuridik manzil;",
        "bank BIC kodi;",
        "hisob raqami;",
        "korrespondent hisob raqami;",
        "depozit summasi.",
      ],
    },
    points: {
      title: "Savdo nuqtalari",
      paragraphs: [
        "<b>«Savdo nuqtalari»</b> bo‘limida barcha ro‘yxatdan o‘tgan nuqtalar va chek tarixi ko‘rsatiladi. Zarurat tug‘ilganda nuqtani o‘chirish imkoniyati ham mavjud.",
        "Yangi savdo nuqtasini qo‘shish uchun «Yaratish» tugmasini bosing. So‘ng barcha majburiy maydonlarni to‘ldiring. Qulaylik uchun maydonlar yonida maslahatlar mavjud. Muassasangiz faoliyatini iloji boricha batafsil va aniq tasvirlab, uning o‘ziga xosligini tavsif va rasmlar orqali ta’kidlang.",
        "Hisob-kitoblar amalga oshiriladigan yuridik shaxsni ko‘rsatish muhim. Buning uchun tegishli yuridik shaxsni ro‘yxatdan tanlang. Kiritilgan ma’lumotlar moderatsiyaga yuboriladi. Tekshiruv holatini quyidagi statuslar orqali kuzatishingiz mumkin:",
      ],
      list: [
        "«Tasdiqlandi» — barcha ma’lumotlar to‘g‘ri kiritilgan va tekshiruv muvaffaqiyatli o‘tgan. Bunda sizning nuqtangiz rcpay.ru saytida va RC PAY ilovasida joylashtiriladi.",
        "«Rad etildi» — ma’lumot yetarli emas yoki aniqlashtirish talab etiladi. Moderator tomonidan tushuntiruvchi xabar yuboriladi.",
        "«Moderatsiyada» — nuqta tekshiruvni kutmoqda yoki hozirda tekshirilmoqda.",
      ],
      p: "Cheklar tarixini ko‘rish uchun tegishli savdo nuqtasi kartasidagi chek belgisini bosing. Jadvalni filtrlash, saralash yoki muayyan tranzaksiyani batafsil ko‘rish mumkin.",
    },
    documents: {
      title: "Hujjatlar",
      p: "«Hujjatlar» bo‘limidagi «Hujjatlar» va «Marketing materiallari» yorliqlarida RC GROUP mahsulotlariga oid yo‘riqnomalar va materiallar bilan tanishishingiz mumkin.",
    },
    tariffs: {
      title: "Tariflar",
      p: "<b>«Tariflar»</b> bo‘limida mavjud barcha tariflar ko‘rsatilgan. Tarif sotib olish uchun keraklisini tanlab, «Tarifni sotib olish» tugmasini bosing, so‘ng «Yuridik shaxs»ni tanlang va «To‘lash» tugmasini bosing. To‘lovni amalga oshirish uchun balansni to‘ldirib, «Balans» bo‘limida hisob yarating va uni tanlangan tashkilot rekvizitlari orqali to‘lang.",
    },
  },

  paymentDecision: {
    title: "To‘lov yechimi",
    paymentMethod: {
      title: "To‘lov usullari",
      p1: "To‘lov yechimini ulashdan oldin ko‘rsatmalar bilan tanishib chiqing — bu sizga ish uchun zarur shartlarni bilishga yordam beradi. Shuningdek, sizning muassasangiz to‘lov yechimini ulash mumkin bo‘lmagan toifalarga kirmasligiga ishonch hosil qiling.<br /><br /> <b>«To‘lov usullari»</b> bo‘limida siz to‘lov yechimini ulamoqchi bo‘lgan savdo nuqtasini ro‘yxatdan tanlashingiz mumkin.<br /> Savdo nuqtasini tanlaganingizdan so‘ng, ariza yaratish imkoniyati ochiladi.<br /><br /> Arizani yuborishdan oldin ma’lumotlarni tekshirib chiqing:",
      list: [
        "Aloqa ma’lumotlari: manzil va telefon raqami. <br /> Telefon raqami kassadagi chekda ko‘rsatiladi va siz bilan bog‘lanish uchun kerak.",
        "Yuridik shaxs: barcha ma’lumotlarning to‘g‘riligini tekshiring.",
        "Bank rekvizitlari: kiritilgan ma’lumotlarning to‘g‘riligiga e’tibor bering.",
      ],
      p2: "Agar rekvizitlarda xato topsangiz, o‘zgartirish uchun qo‘llab-quvvatlash xizmatiga murojaat qiling — buni o‘ng pastki burchakdagi aloqa shakli orqali amalga oshirishingiz mumkin.<br /><br /> Barcha ma’lumotlar kiritilgandan so‘ng quyidagi bandlar yonidagi katakchalarni belgilang: «Shaxsiy ma’lumotlarimni <b>Maxfiylik siyosati</b>ga muvofiq qayta ishlashga roziman» va «Litsenziya shartnomasi hamda Shaxsiy ma’lumotlarni qayta ishlash siyosati shartlarini qabul qilaman». So‘ng «Arizani yuborish» tugmasini bosing.<br /><br /> Ariza yuborilgandan so‘ng, RC GROUP menejeri siz bilan bog‘lanadi va ulanish bo‘yicha keyingi harakatlar haqida ma’lumot beradi.<br /><br /> Shuningdek, <b>«To‘lov usullari»</b> bo‘limida «Arizalar tarixi» yorlig‘ida to‘lov yechimini ulash holatini kuzatishingiz mumkin.<br /><br /> Mijozlardan to‘lovlarni qabul qilishni boshlash uchun savdo nuqtasini yaratish, tovarlarni qo‘shish va RC PAY orqali tovarlar mavjud bo‘lgan savdo nuqtalarida buyurtma qabul qilish funksiyasini yoqish kerak.",
    },
  },

  services: {
    title: "Servislar",
    eMenu: {
      title: "Onlayn katalog",
      p: "<b>«Onlayn katalog»</b> sahifasida siz o‘z mahsulotlaringiz yoki xizmatlaringizni qo‘shishingiz mumkin, shunda mijozlar rcpay.ru sayti yoki RC PAY ilovasi orqali sizning muassasangiz yoki do‘koningiz assortimenti bilan tanishishlari mumkin. Shuningdek, sahifaning pastki qismida QR-kod yaratib, yuklab olishingiz mumkin — bu sizning savdo nuqtangizning menyusiga bir necha bosish bilan o‘tishni ta’minlaydi.",
    },
  },

  contacts: {
    title: "Kontaktlar",
    p: "Barcha savollar bo‘yicha <b>8 (800) 500-57-62</b> telefon raqamiga yoki hello&#64;rc.city elektron pochta manziliga murojaat qiling. Yoki o‘ng pastki burchakdagi aloqa formasidan foydalanib savolingizni yuboring, biz siz bilan qulay tarzda bog‘lanamiz.",
  },
};
